<template>
  <img
    class="bdc-help-icon"
    :class="iconClass"
    :style="iconStyle"
    :src="iconSrc"
    alt=""
    aria-hidden="true"
  >
</template>

<script>
export default {
  name: 'BdcHelpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 15
    },
    iconClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iconSrc: require('@Sys~/assets/bdc-nav/icon-info.svg')
    }
  },
  computed: {
    iconStyle() {
      const size = Number(this.size) || 15
      return {
        width: `${size}px`,
        height: `${size}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bdc-help-icon {
  display: block;
  flex-shrink: 0;
  object-fit: contain;
  vertical-align: middle;
}
</style>
